import React from 'react';
import { Translate } from "react-localize-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { writeErr } from '../../common/logger';
import UnderlinedTitle from "../../common/underlinedTitle";

import '../rating/paymentChart.scss';

const prepareData = (data, prop) => {
    let r = [];
    data.map((d) => {
        if (!d.hasOwnProperty(prop)) {
            writeErr("Property not in data object");
            return r;
        }
        else {
            r.push({ amount: d[prop], amountFormatted: d[prop + 'Formatted'], year: new Date(d.end).getFullYear() });
        }

    })
    return r;
}

const FinanceChart = ({ data, whichProp, header, color }) => {
    const tableData = prepareData(data, whichProp);
    const chartData = [...tableData].sort((a, b) => a.year - b.year);
    return (
        <React.Fragment>
            <div className="finance-chart">
                <UnderlinedTitle header={header} />
                <br />
                <ResponsiveContainer width="99%" height={235} >
                    <BarChart title={header} data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid vertical={false} />
                        <YAxis stroke="#8d949e" dataKey="amount" type="number"></YAxis>
                        <XAxis stroke="#8d949e" dataKey="year" type="category"></XAxis>

                        <defs>
                            <linearGradient id="colorSales" gradientTransform="rotate(90)">
                                <stop className="finance-chart-stop-sales-5" offset="5%" stopOpacity={1} />
                                <stop className="finance-chart-stop-sales-95" offset="95%" stopOpacity={1} />
                            </linearGradient>
                            <linearGradient id="colorProfit" gradientTransform="rotate(90)">
                                <stop className="finance-chart-stop-profit-5" offset="5%" stopOpacity={1} />
                                <stop className="finance-chart-stop-profit-95" offset="95%" stopOpacity={1} />
                            </linearGradient>
                            <linearGradient id="colorAsset" gradientTransform="rotate(90)">
                                <stop className="finance-chart-stop-asset-5" offset="5%" stopOpacity={1} />
                                <stop className="finance-chart-stop-asset-95" offset="95%" stopOpacity={1} />
                            </linearGradient>
                        </defs>
                        <Tooltip cursor={false} content={<CustomTooltip header={header} />} wrapperStyle={tooltipStyle} />
                        <Bar radius={[10, 10, 0, 0]} barSize={25} dataKey="amount" fill={color} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
            {tableData.length > 0 &&
                <table className="table table-report-section-3">
                    <thead>
                        <tr>
                            <th className="w-50"><Translate id="Report.FinancialStatements.Period" /></th>
                            <th className="w-50">{header}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((f, i) => {
                            return (
                                <tr key={i} className="colorize">
                                    <td className="w-50 bold">{f.year}</td>
                                    <td className="w-50">{f.amountFormatted}</td>
                                </tr>)
                        })}
                    </tbody>
                </table>
            }
        </React.Fragment>
    )
}

const tooltipStyle = {
    textAlign: 'center',
    fontSize: '0.8em',
    padding: "0.35em 2em",
    background: "#FFF",
    border: "1px solid #DEDEDE",
    boxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)",
    WebkitBoxShadow: "0px 1px 4px 1px rgba(68, 71, 73, 0.1)"
}
const CustomTooltip = ({ active, payload, header }) => {
    if (active && payload[0]) {
        return (
            <div className="payment-chart-tooltip">
                <div style={{ fontWeight: "600", fontSize: "1.2em" }}>{payload[0].payload.amountFormatted}{` ${header.substring(header.indexOf('(') + 1, header.indexOf(')'))}`}</div>
                <div style={{ fontSize: "1em" }}>{payload[0].payload.year} </div>
            </div>
        )
    }
    return null;
}

export default FinanceChart;